import axios from 'axios'
import type { AxiosRequestConfig } from 'axios'

const baseUrl = '/api'
const DEFAULT_HEADERS = { 'Content-Type': 'application/json' }

export type ApiOptions = AxiosRequestConfig & {
  formData?: FormData
}

export type ApiResponse<T> = { data: T; status: number }

async function sendRequest<T>(method: 'GET' | 'POST' | 'DELETE' | 'PUT', options: ApiOptions): Promise<ApiResponse<T>> {
  const config: AxiosRequestConfig = {
    method,
    ...options,
    url: `${baseUrl}${options.url}`,
    data: options.data || {},
    headers: { ...DEFAULT_HEADERS, ...options.headers },
  }

  if (options.formData) {
    config.data = options.formData
  }

  const response = await axios(config)
  return { data: response.data as T, status: response.status }
}

/**
 * Base URL is set as `/api`.
 */
const api = {
  async get<T>(options: ApiOptions): Promise<ApiResponse<T>> {
    return sendRequest<T>('GET', options)
  },
  async post<T>(options: ApiOptions): Promise<ApiResponse<T>> {
    return sendRequest<T>('POST', options)
  },
  async delete<T>(options: ApiOptions): Promise<ApiResponse<T>> {
    return sendRequest<T>('DELETE', options)
  },
  async put<T>(options: ApiOptions): Promise<ApiResponse<T>> {
    return sendRequest<T>('PUT', options)
  },
}

export default api
